import { z } from 'zod';
import { CoreCustomListViewAccessLevelSchema } from '../inputTypeSchemas/CoreCustomListViewAccessLevelSchema'
import { CoreObjectTypeSchema } from '../inputTypeSchemas/CoreObjectTypeSchema'

/////////////////////////////////////////
// CORE CUSTOM LIST VIEW SCHEMA
/////////////////////////////////////////

export const CoreCustomListViewSchema = z.object({
  accessLevel: CoreCustomListViewAccessLevelSchema,
  objectType: CoreObjectTypeSchema,
  id: z.number().int(),
  cityId: z.number().int(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  name: z.string(),
  isDefault: z.boolean(),
  isReadOnly: z.boolean(),
  userId: z.number().int(),
  departmentId: z.number().int().nullable(),
  filterGroupId: z.number().int().nullable(),
  query: z.string().nullable(),
})

export type CoreCustomListView = z.infer<typeof CoreCustomListViewSchema>

export default CoreCustomListViewSchema;
